import { Carousel } from "@atoms/Carousel";
import { Box } from "@mui/material";
import React, { useState } from "react";
import { ProductCard } from "./ProductCard";

export interface ProductCardCarouselData {
  id: string | number;
  title: string;
  description?: string;
  subTitle?: string;
  image?: string;
  linkTo?: string;
  label?: string;
  imageUrl?: string;
  category?: string;
  categoryId?: string;
}

export interface ProductCardCarouselProps {
  data: ProductCardCarouselData[];
  labelInline?: boolean;
  cardHeight?: number | string;
  imgHeight?: number;
  imageInsideBox?: boolean;
  imageInsight?: boolean;
  titleMaxLine?: number;
}

export const ProductCardCarousel: React.FC<ProductCardCarouselProps> = ({
  data,
  labelInline,
  cardHeight,
  imageInsideBox,
  imageInsight,
  imgHeight,
  titleMaxLine,
}) => {
  const [activeId, setActiveId] = useState(0);

  return (
    <Box
      sx={{
        ".slick-track": { display: "flex" },
        ".slick-list": { paddingLeft: activeId === 0 ? "0 !important" : undefined },
        ".productcard-title": {
          fontSize: "14px",
          fontWeight: 600,
          lineHeight: 1.4,
        },
      }}
    >
      <Carousel
        settings={{
          slidesToShow: 1,
          infinite: false,
          beforeChange: (idx, nextid) => {
            setActiveId(nextid);
          },
        }}
        centerMode={true}
        arrows={false}
      >
        {data.map((item) => {
          return (
            <Box px="12px" key={item.id}>
              {imageInsight ? (
                <ProductCard
                  title={item.title}
                  description={item.description}
                  subTitle={item.subTitle}
                  imageUrl={item.image}
                  linkTo={item.linkTo}
                  height={cardHeight ? cardHeight : "300px"}
                  label={item.label}
                  titleMaxLine={3}
                  withImagePlaceholder
                  labelInline={labelInline}
                  imageInsideBox={imageInsideBox}
                  imageHeight={imgHeight ? imgHeight : 84}
                />
              ) : (
                <ProductCard
                  title={item.title}
                  description={item.description}
                  subTitle={item.subTitle}
                  image={item.image}
                  imageHeight={imgHeight ? imgHeight : 84}
                  height={cardHeight ? cardHeight : "188px"}
                  overflow="hidden"
                  linkTo={item.linkTo}
                  label={item.label}
                  titleMaxLine={titleMaxLine ? titleMaxLine : 2}
                  withImagePlaceholder
                  labelInline={labelInline}
                  imageInsideBox={imageInsideBox}
                />
              )}
            </Box>
          );
        })}
      </Carousel>
    </Box>
  );
};
